import React from 'react'

import { Form, Placeholder } from '@s4l/ds'
import styles from '../styles.module.css'

import RadioItem from '../../RadioItem'

function RadioSectionPlaceholder() {
  return (
    <div className={styles.container}>
      <Form.Fieldset>
        <Form.Legend>
          <Placeholder height="1em" width="60%" rounded />
        </Form.Legend>
        <ul>
          {Array.from({ length: 3 }).map((_, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <RadioItem.Placeholder key={i} />
          ))}
        </ul>
      </Form.Fieldset>
    </div>
  )
}
RadioSectionPlaceholder.displayName = 'RadioSectionPlaceholder'

export default RadioSectionPlaceholder
